(ns hypnos.consumer.panels.consult.not-found)

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; API

(defn step
  "Error message when the step could not be found."
  []
  [:div "Page not found!"])
